import { empty } from '@/helpers/helpers'
import { withTenantKey } from '@/libs/storageKeys'

/* eslint-disable no-param-reassign */
const hasAtLeastOneRole = (userRoles, requiredRoles) => {
  let granted = false

  if (typeof requiredRoles === 'undefined') {
    granted = true
  } else {
    for (let i = 0; i < userRoles.length; i += 1) {
      for (let j = 0; j < requiredRoles.length; j += 1) {
        if (userRoles.includes(requiredRoles[j])) {
          granted = true
          break
        }
      }
      if (granted) {
        break
      }
    }
  }
  return granted
}

const getStoredUserRoles = () => {
  try {
    const userInfoRaw = localStorage.getItem(withTenantKey('userInfo'))
    if (!userInfoRaw) {
      return []
    }

    const userInfo = JSON.parse(userInfoRaw)

    return Array.isArray(userInfo?.roles) ? userInfo.roles : []
  } catch (error) {
    return []
  }
}

const visibleToRole = (el, binding) => {
  const elementRoles = binding.value
  const userRoles = getStoredUserRoles()
  const accessGranted = hasAtLeastOneRole(userRoles, elementRoles)
  if (empty(userRoles) || !accessGranted) {
    if (el.vVisibleToRoleDisplay === undefined) {
      el.vVisibleToRoleDisplay = el.style.display || ''
    }
    el.style.display = 'none'
    el.setAttribute('aria-hidden', 'true')
    return
  }
  if (el.vVisibleToRoleDisplay !== undefined) {
    el.style.display = el.vVisibleToRoleDisplay
    delete el.vVisibleToRoleDisplay
  } else if (el.style.display === 'none') {
    el.style.display = ''
  }
  el.removeAttribute('aria-hidden')
}

export default {
  visibleToRole,
  hasAtLeastOneRole,
  getStoredUserRoles,
}
